import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getData } from '../../Actions/DropDown/getData';

class Radio extends React.PureComponent {
  componentWillMount() {
    this.props.getData({ key: this.props.dataKey });
  }

  componentWillReceiveProps(props) {
    if (props.options && props.options.length === 1) {
      this.props.onChange(props.options[0][(props.editable ? 'id' : 'key')]);
      return;
    }
  }

  update = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <div className="input-radio-group">
        {this.props.options.length === 0 ? <span className="loading-text">Loading...</span> : null}
        {this.props.options.map(o => (
          <div className={['input-radio', this.props.classes && this.props.classes].join(' ')} key={o.id + this.props.name}>
            <input
              type="radio"
              id={this.props.name + (this.props.editable ? o.value : o.key)}
              value={this.props.editable ? o.id : o.key}
              onChange={this.update}
              name={this.props.name}
              checked={(this.props.name === 'assessment[smoking_type_id]' || this.props.name === 'smokingtype') ? (this.props.value === (o.id).toString()) : (this.props.value === (this.props.editable ? o.value : o.key))}
              key={this.props.name + o.id}
            />
            <label key={o.id + this.props.name + o.id} htmlFor={this.props.name + (this.props.editable ? o.value : o.key)}>{o.id === 3996 ? 'Prefer to self describe' : o.value}</label>
          </div>
        ))}
      </div>
    );
  }
}

Radio.propTypes = {
  dataKey: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  editable: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const data = {
    ...ownProps,
    options: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].options : [],
    editable: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].editable : 0,
  };

  data.options.sort((a, b) => (a.value > b.value ? 1 : -1));
  return data;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getData: (p) => { dispatch(getData(p)); },
});

const RadioLink = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Radio);

export default RadioLink;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Radio.jsx